'use es6';

import { INVOICE_TYPE_ID } from '../../../data/objectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const Invoice = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: (_, hasScope) => hasScope('accounting-extension-read'),
  objectTypeId: INVOICE_TYPE_ID,
  referenceObjectType: 'INVOICE_PROPERTIES'
});
export default Invoice;